import * as http from 'utils/http';
import { updateUserFromDriver } from 'redux/modules/carrier-section/duck';

export const checkUsername = (username) => {
  return (dispatch, getState, config) => {
    return http
      .get(`${config.API_URL}users/?username=${username}`)
      .then((users) => Boolean(users.count))
      .catch((err) => {
        throw err;
      });
  };
};

export const createUser = (user, driverId) => {
  return (dispatch, getState, config) => {
    return http
      .post(`${config.API_URL}users/`, user)
      .catch((err) => {
        throw err;
      })
      .then((response) => {
        dispatch(updateUserFromDriver({ user: response, driverId }));
        return response;
      });
  };
};

export const updateUser = (id, user, driverId) => {
  return (dispatch, getState, config) => {
    return http
      .patch(config.API_URL + 'users/' + id + '/', user)
      .catch((err) => {
        throw err;
      })
      .then((response) => {
        if (driverId) {
          dispatch(updateUserFromDriver({ user: response, driverId }));
        }
        return response;
      });
  };
};

export const createShipperUser = (shipperId, user) => {
  return (dispatch, getState, config) => {
    return http
      .post(`${config.API_URL}shippers/${shipperId}/users/`, user)
      .catch((err) => {
        throw err;
      })
      .then((response) => response);
  };
};

export const updateDriverUser = (id, password = '') => {
  return (dispatch, getState, config) => {
    return http
      .patch(config.API_URL + 'users/' + id + '/', {
        password,
      })
      .catch((err) => {
        throw err;
      })
      .then((response) => response);
  };
};

export const updateShipperUserUsername = (id, username = '') => {
  return (dispatch, getState, config) => {
    return http
      .patch(config.API_URL + 'users/' + id + '/', {
        username,
      })
      .catch((err) => {
        throw err;
      })
      .then((response) => response);
  };
};

export const updateShipperUserPassword = (id, password = '') => {
  return (dispatch, getState, config) => {
    return http
      .patch(config.API_URL + 'users/' + id + '/', {
        password,
      })
      .catch((err) => {
        throw err;
      })
      .then((response) => response);
  };
};

export const deleteUser = (id) => {
  return (dispatch, getState, config) => {
    return http
      ._delete(config.API_URL + 'users/' + id + '/')
      .catch((err) => {
        throw err;
      })
      .then((response) => response);
  };
};
